import script from "./BodySubMain.vue?vue&type=script&setup=true&lang=js"
export * from "./BodySubMain.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodySubMain.vue?vue&type=style&index=0&id=53507c5e&module=bodySubMain&lang=css"
cssModules["bodySubMain"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__